import { Partner } from '../../models/partners.interfaces';

export const Partners3ItemsMocks: Partner[] = [
  {
    id: 'earnMilesWithEveryLyft',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/lyft-logo.svg',
      alt: 'Lyft Logo'
    },
    action: {
      label: 'Link Account',
      url: 'https://www.deltalyft.com/'
    },
    title: 'Earn Miles With Every Lyft'
  },
  {
    id: 'earnMilesWithStarbucks',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/starbucks-logo.svg',
      alt: 'Starbucks Logo'
    },
    action: {
      label: 'Link Account',
      url: 'https://www.deltalyft.com/'
    },
    title: 'Earn Miles With Starbucks'
  },
  {
    id: 'earnMilesWithEveryOrder',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/instacart-logo.svg',
      alt: 'Instacart Logo'
    },
    action: {
      label: 'Link Account',
      url: 'https://www.delta.com/instacart'
    },
    title: 'Earn Miles With Every Order'
  }
];
